import { useInfiniteQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import type { GoodsListType } from 'shared/src/api';
import { queryKey } from '../../GoodsDetail/constant/queryKey';
import { convertGoodsListItemToGoodsData } from '../utils/convertGoodsListItemToGoodsData';

type Params = {
  type: GoodsListType;
  goodsSno: number;
  position?: string;
  from?: string;
  perPage?: number;
  isDeliveryFilterOn?: boolean;
};

const DELIVERY_TYPE_FAST = 1;

export const useGoodsList = ({
  type,
  goodsSno,
  position,
  from,
  perPage,
  isDeliveryFilterOn = false,
}: Params) => {
  return useInfiniteQuery({
    queryKey: queryKey.goodsList({
      type,
      goodsId: goodsSno,
      isDeliveryFilterOn,
      position,
      from,
      perPage,
    }),
    queryFn: ({ pageParam }) =>
      goodsService.getGoodsList({
        type,
        goods_sno: goodsSno,
        last_sno: pageParam > 0 ? pageParam : undefined,
        position,
        from,
        per_page: perPage,
        delivery_type: isDeliveryFilterOn ? DELIVERY_TYPE_FAST : undefined,
      }),
    initialPageParam: 0,
    getNextPageParam: lastPage => {
      const lastGoods = lastPage.goods[lastPage.goods.length - 1];
      return lastGoods?.sno;
    },
    select: data => ({
      ...data.pages[data.pages.length - 1],
      total: data.pages[0]?.total ?? 0,
      goods: data.pages.flatMap(page =>
        page.goods.map(convertGoodsListItemToGoodsData),
      ),
    }),
  });
};
